import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MenuService } from "../../../services/menus/menu.service";
import { Subject, takeUntil } from "rxjs";
import { MessageService } from "primeng/api";

@Component({
  selector: 'app-delete-category',
  templateUrl: './delete-category.component.html',
  styleUrls: ['./delete-category.component.scss']
})
export class DeleteCategoryComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public spinner: boolean = false;
  public categoryId: string;
  //#endregion

  //#region Constructor
  constructor(
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private messageService: MessageService,
    private menuService: MenuService
  ) {
    if (this.config.data != undefined && this.config.data.id) {
      this.categoryId = this.config.data.id;
    }
  }

  ngOnInit(): void {
  }
  //#endregion

  //#region Public Methods
  deleteCategory(categoryId: string) {
    this.spinner = true;
    this.menuService.deleteCategory(categoryId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.ref.close(true);
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({ severity: 'error', summary: "System error", life: 2000 });
        }
      });
  }

  cancel(): void {
    this.ref.close(false);
  }
  //#endregion
}
